import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import LoadingIcon from '../shared/LoadingIcon';
import Link from '../shared/Link';
import i18n from '../../config/i18n';
import {
  FPP_SECTION,
  WOUND_SECTION,
} from '../../constants/SectionNames';

const styles = {
  thead: {
    backgroundColor: '#607484', color: '#FFF',
  },
  button: {
    padding: '10px 10px',
    margin: '3px 10px',
    width: '125px',
  },
};

class PatientList extends Component {
  preparePatientsListHtml = (patient, index) => {
    const { router } = this.props;
    return (
      <tr key={patient.id}>
        <td>{index + 1}</td>
        <td>
          {
            /*
              SSN is 9-digit but Taiwan ID is a letter + 9 digits.
              "XXX-XX-" would have trouble to handle Taiwan ID properly.
            */
          }
          <Link href={`medical-records/${patient.id}`} router={router}>
            {`XXX-XX-${patient.identification.substr(-4)}`}
          </Link>
        </td>
        <td>{`${_.capitalize(patient.firstName)} ${_.capitalize(patient.lastName)}`}</td>
        <td>{moment(patient.dateOfBirth).format('YYYY-MM-DD')}</td>
        <td>
          <Link
            href={`/medical-records/${patient.id}/refer`}
            className="btn btn-sm btn-info"
            style={styles.button}
            router={router}
          >
            <i className="glyphicon glyphicon-share" />
            {i18n.t('refer')}
          </Link>
          <Link
            href={`/medical-records/${patient.id}?section=${FPP_SECTION}`}
            className="btn btn-sm btn-info"
            style={styles.button}
            router={router}
          >
            {i18n.t('GuruGaitTM')}
          </Link>
          <Link
            href={`/medical-records/${patient.id}?section=${WOUND_SECTION}`}
            className="btn btn-sm btn-info"
            style={styles.button}
            router={router}
          >
            {i18n.t('GuruWoundsTM')}
          </Link>
        </td>
      </tr>
    );
  }

  preparePatientsLoadingHtml = () => (
    <tr>
      <td><LoadingIcon /></td>
      <td />
      <td />
      <td />
      <td />
    </tr>
  )

  prepareNoPatientsHtml = () => (
    <tr>
      <td>{i18n.t('noPatientDataMsg')}</td>
      <td />
      <td />
      <td />
      <td />
    </tr>
  )

  preparePatientsHtml = () => {
    const {
      isLoading,
      patientData,
    } = this.props;

    if (isLoading) {
      return this.preparePatientsLoadingHtml();
    }
    if (!patientData.length) {
      return this.prepareNoPatientsHtml();
    }
    return patientData.map((patient, index) =>
      this.preparePatientsListHtml(patient, index));
  }

  render() {
    const patientHtml = this.preparePatientsHtml();
    return (
      <table className="table table-striped table-hover table-responsive PatientList">
        <thead style={styles.thead}>
          <tr>
            <th>#</th>
            <th>{i18n.t('id')}</th>
            <th>{i18n.t('name')}</th>
            <th>{i18n.t('d_o_b')}</th>
            <th>{i18n.t('actions')}</th>
          </tr>
        </thead>
        <tbody>
          {patientHtml}
        </tbody>
      </table>
    );
  }
}

PatientList.propTypes = {
  router: PropTypes.object.isRequired,
  patientData: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default PatientList;



// WEBPACK FOOTER //
// ./src/components/patient/PatientList.js